export const LightTheme = {
    bg: "#f8fdff",
    on_bg: "#001f25",
    primary: "#00696c",
    on_primary: "#ffffff",
    p_container: "#6ff6fa",
    on_p_container: "#002021",
    secondary: "#725c00",
    tertiary: "#006b56",
    on_tertiary: "#ffffff",
    t_container: "#7ef8d4",
    on_t_container: "#002018",
    outline: "#6f7979",
    surface: "#dae4e4",
    on_surface: "#3f4949",
    error: "#ba1a1a",
    on_error: "#ffffff"
}
export const DarkTheme = {
    bg: "#001f25",
    on_bg: "#a6eeff",
    primary: "#4cd9de",
    on_primary: "#003738",
    p_container: "#004f51",
    on_p_container: "#6ff6fa",
    secondary: "#e7c349",
    tertiary: "#60dbb9",
    on_tertiary: "#00382b",
    t_container: "#005140",
    on_t_container: "#7ef8d4",
    outline: "#899393",
    surface: "#3f4949",
    on_surface: "#bec8c8",
    error: "#ffb4ab",
    on_error: "#690005",
}